import type { PropType } from 'vue';

export default {
  mayViewPassword: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
};
